import type { FC, FormEvent } from 'react';

import useDispatch from '@app/hooks/useDispatch';
import useSelector from '@app/hooks/useSelector';

import type { OauthHeaderProps } from '../../components';
import { twoFactorSelector } from '../../selectors';
import TwoFactorPage from './TwoFactorPage';
import { twoFactorLoginActions } from './reducers';

export { twoFactorLoginActions };

interface TwoFactorPageContainerProps {
    text: Record<string, string>;
    oauthDetail?: OauthHeaderProps;
    // eslint-disable-next-line react/no-unused-prop-types
    fromUri?: string | undefined;
    logoutHref: string;
}

export interface TwoFactorFormDataType {
    code: string;
}

const TwoFactorPageContainer: FC<TwoFactorPageContainerProps> = ({ text, logoutHref, oauthDetail }) => {
    const dispatch = useDispatch();
    const { formData, loading, error } = useSelector(twoFactorSelector);

    const handleDataChange = (data: TwoFactorFormDataType) => {
        dispatch(twoFactorLoginActions.updateFormData(data));
    };

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (loading) {
            return;
        }
        dispatch(twoFactorLoginActions.twoFactorLogin());
    };

    return (
        <TwoFactorPage
            text={text}
            logoutHref={logoutHref}
            oauthDetail={oauthDetail}
            loading={loading}
            error={error}
            formData={formData}
            onSubmit={handleSubmit}
            onFormDataChange={handleDataChange}
        />
    );
};

export default TwoFactorPageContainer;
